import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import type { ReactNode } from "react";

function GoogleGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 11v2.9h4.1a3.6 3.6 0 0 1-1.55 2.35l2.5 1.94C18.6 16.77 19.4 14.6 19.4 12c0-.6-.05-1.18-.15-1.73H12V11Zm-6.9 1a6.9 6.9 0 0 1 .35-2.16L2.9 7.86A11 11 0 0 0 1.7 12c0 1.5.35 2.92.98 4.18l2.6-2.02A6.9 6.9 0 0 1 5.1 12Zm6.9 6.9a6.9 6.9 0 0 1-6-3.5l-2.6 2.02A11 11 0 0 0 12 23c2.97 0 5.46-.98 7.28-2.66l-2.6-2.02A6.8 6.8 0 0 1 12 18.9Zm0-13.8c1.7 0 3.05.65 4 1.5l2.28-2.28A11 11 0 0 0 12 1 11 11 0 0 0 2.9 7.86l2.55 1.98A6.9 6.9 0 0 1 12 5.1Z"
      />
    </svg>
  );
}

function XGlyph() {
  return (
    <svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584l-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"
      />
    </svg>
  );
}

const SOCIALS: Array<{ href: string; label: string; icon: ReactNode }> = [
  {
    href: "https://www.linkedin.com/company/berk-hospitality-group",
    label: "Berk Hospitality Group on LinkedIn",
    icon: <Linkedin size={17} strokeWidth={1.6} aria-hidden="true" />,
  },
  {
    href: "https://www.instagram.com/berkhospitality/",
    label: "Berk Hospitality Group on Instagram",
    icon: <Instagram size={17} strokeWidth={1.6} aria-hidden="true" />,
  },
  {
    href: "https://www.facebook.com/people/Berk-Hospitality-Group/61567084135408/",
    label: "Berk Hospitality Group on Facebook",
    icon: <Facebook size={17} strokeWidth={1.6} aria-hidden="true" />,
  },
  {
    href: "https://x.com/BerkHospitality",
    label: "Berk Hospitality Group on X",
    icon: <XGlyph />,
  },
  {
    href: "https://www.google.com/search?kgmid=/g/11mlyjsk2f",
    label: "Berk Hospitality Group on Google",
    icon: <GoogleGlyph />,
  },
  {
    href: "https://www.youtube.com/@berkhospitality",
    label: "Berk Hospitality Group on YouTube",
    icon: <Youtube size={17} strokeWidth={1.6} aria-hidden="true" />,
  },
];

export function SocialLinks({ className = "" }: { className?: string }) {
  return (
    <ul className={`flex items-center gap-3 ${className}`}>
      {SOCIALS.map((s) => (
        <li key={s.href}>
          <a
            href={s.href}
            rel="me noopener"
            target="_blank"
            aria-label={s.label}
            title={s.label}
            className="flex items-center justify-center transition-colors"
            style={{
              width: 34,
              height: 34,
              borderRadius: 999,
              border: "1px solid rgba(251,250,246,0.28)",
              color: "rgba(251,250,246,0.85)",
            }}
          >
            {s.icon}
          </a>
        </li>
      ))}
    </ul>
  );
}
